// import defaultContent from "../default";
import { iconsSet as icons } from "../../../../assets/icons/icons";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_jonasmarchioro.png",
      alt: "Estratégias Jonas Marchioro",
    },
    title: "Negocie com inteligência ",

    // String ou array de strings
    text: "Com foco em trazer diferencial de tudo que já existe neste mercado de trade, Jonas Marchioro desenvolveu uma tese de investimento que visa negociar utilizando a mesma dinâmica usada pelas corretoras que é o RLP, após validar esta desde desde 2018 transformou isso em um software que agora vai te ajudar a ganhar dinheiro de verdade na bolsa de valores. ",
    testimonial: {
      text: "Foque em identificar os perdedores, e assim, fazendo o inverso achará o caminho para tornar-se um ganhador.",
      author: {
        name: "Jonas Marchioro",
        picture: "",
      },
    },
  },

  strategies: {
    title: "Estratégias Seguidoras de RLP",
    heading: "Comece agora mesmo a fazer o diferente",
    subtitle:
      "As estratégias usam um indicador proprietário desenvolvido pelo Jonas Marchioro que visa realizar as operações usando a mesma dinâmica que as corretoras usam o famoso RLP.",
  },

  cta: {
    title: "Aqui está sua mudança!",
    subtitle: "Saia do básico e comece agora mesmo a usar algo inovador.",
    // buttonText: "Ativar",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "Jonas Marchioro",
    col1: [
      "Olá pessoal, tudo bem? Aqui é o Jonas e estou no mercado há mais de 15 anos. Tenho 38 anos, moro no Rio Grande Do Sul, sou cristão e pai de duas princesas.",
      "Iniciei no mercado financeiro em 2007. Provavelmente, assim como você, eu já perdi muito dinheiro, mas não desisti. Há alguns anos desenvolvi uma tese de investimentos que hoje está disponível para você. Tese essa que visa executar a mesma dinâmica que é usada pelas corretoras: o RLP. Ou seja, fazer a operação contrária da pessoa física, que sabemos que mais perde que ganha, e quando ganha é pouco, e quando perde é muito.",
    ],
    col2: [
      "Meu método proprietário visa fazer esta mesma negociação que as corretoras fazem, que é o RLP, porém em swing trade.",
      "Quero desde já agradecer por confiar no meu trabalho. Jonas Marchioro",
    ],
  },

  stats: {
    title: "Onde já chegamos",
    subtitle: "Em 15 anos este foram meus números",
    data: [
      {
        value: "+3k",
        description: "Clientes",
      },
      {
        value: "+2mi",
        description: "Ganhos no mercado",
      },
      {
        value: "+2k",
        description: "Contratos negociados diariamente",
      },
    ],
  },

  features: {
    title: "Por que utilizar os meus robôs?",
    subtitle: "Veja quais as principais vantagens.",
    data: [
      {
        icon: icons.lightbulb,
        title: "Indicador inovador",
        description:
          "O indicador usado para executar as operações é proprietário de desenvolvido com a mesma tese das operações realizadas pelas corretoras o RLP",
      },
      {
        icon: icons.filter,
        title: "Poucas operações",
        description:
          "Baixa quantidade de operações o que reduz o risco e o custo operacional.",
      },
      {
        icon: icons.pie_chart,
        title: "Diversos ativos",
        description:
          "Com nossa tese é possível negociar Mini Índice Mini Dólar e Bova 11",
      },
      {
        icon: icons.graduation_cap,
        title: "Operações validadas por analistas",
        description:
          "Todas as operações são supervisionadas por um analista credenciado pela Apimec",
      },
      {
        icon: icons.calendar,
        title: "Swing Trade",
        description:
          "Maior parte das operações são realizadas em swing trade, o que reduz muito o risco",
      },
      {
        icon: icons.test_tube,
        title: "Profissionais com experiência",
        description:
          "Todos profissionais envolvidos possuem muitos anos de experiência no mercado.",
      },
      // ...defaultContent.features.data,
    ],
  },

  testimonials: [
    {
      text: "O que mais acho legal nas estratégias é que elas conseguem surfar um ganho longo, ou seja, ganhos grandes e perdas pequenas, isso me dá uma segurança maior.",
      author: "Villeneuve Melo Garcia",
      job: "Vendedor",
      // image_url:
      //   "https://ontick-img.s3.sa-east-1.amazonaws.com/flavio-rezende.png",
    },
    {
      text: "Já usei outras ferramentas mas confesso que a mais consistente e resiliente ao longo do tempo foram os robôs do Jonas, ganha e permanece com o ganho, já outras experiências que tive o que ganhei em um mês perdia em 1 dia, muito grato Jonas.",
      author: "Pamela Martuscelli",
      job: "Do lar",
      // image_url:
      //   "https://ontick-img.s3.sa-east-1.amazonaws.com/david-souza.png",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Conheça os planos e veja qual se adequa melhor ao seu perfil.",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
